// defaults/defaultProperty.js

const defaultProperty = {
  address: '',
  city: '',
  province: '',
  postalCode: '',
  /** URL (Firebase Storage) affichée dans le rapport PDF — première photo de la galerie */
  buildingImageUrl: '',
  /** Galerie (URLs) ; la première sert pour PDF / e-mail pocket */
  buildingImageUrls: [],
  /** Description marketing (HTML) — pocket deals, rapports */
  marketingDescriptionHtml: '',
  askingPrice: '',
  purchasePrice: '',
  municipalEvaluation: '',
  numberOfUnits: '',
  structureType: 'woodFrame',
  /** Barèmes SCHL : 2023-2024 ou 2025-2026 (en vigueur 8 juin 2026) */
  schlBenchmarkVersion: '2025-2026',
  /**
   * Objectif du deal : analyse d'acquisition vs immeuble déjà détenu.
   * Absence du champ = 'acquisition' (rétrocompatibilité).
   */
  dealPurpose: 'acquisition',

  // Revenus
  annualRent: '',
  parkingRevenue: '',
  internetRevenue: '',
  storageRevenue: '',
  otherRevenue: '',
  /** Vacances / mauvaises créances (% du revenu brut — saisie dans la section revenus) */
  vacancyRate: '3',

  // Dépenses simplifiées
  municipalTaxes: '',
  schoolTaxes: '',
  insurance: '',
  electricityHeating: '',
  maintenance: '',
  concierge: '',
  managementRate: '',
  operatingExpenses: '',
  otherExpenses: '',


  // Dépenses avancées
  heating: '',
  electricity: '',
  landscaping: '',
  snowRemoval: '',
  extermination: '',
  fireInspection: '',
  advertising: '',
  legal: '',
  accounting: '',
  cableInternet: '',
  appliances: '',
  garbage: '',
  washerDryer: '',
  hotWater: '',
  numFridges: '',
  numStoves: '',
  numDishwashers: '',
  numWashers: '',
  numDryers: '',
  numHeatPumps: '',
  numElevators: '',

  // Financement
  financingType: 'conventional',
  aphPoints: '',
  debtCoverageRatio: '1.15',
  qualificationRate: '6.0',
  mortgageRate: '5.5',
  amortization: '25',
  term: '5',

  financingCapRate: '',

  // Frais d'acquisition
  inspection: '',
  environmental1: '',
  environmental2: '',
  environmental3: '',
  otherTests: '',
  appraiser: '',
  expertises: '',
  notary: '',
  renovations: '',
  cmhcAnalysis: '150',
  cmhcTax: '',
  welcomeTax: '',

  // Paramètres futurs
  appreciationRate: 2.5,
  rentIncreaseRate: 2.0,
  expenseIncreaseRate: 2.5,

  /** Courtier immo : mandat de vente (workflow offres / pocket mandat). */
  brokerSaleMandate: false,
  /** active | negotiating | offer_accepted | sold — pilotage affichage accueil (MVP). */
  listingMandateStatus: 'active',

  /** Registre des loyers par logement (tableau de bord). */
  rentRegister: [],
};

export default defaultProperty;
